/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_Switchtofrenchhelper3Inputs */

const en_language_switchtofrenchhelper3 = /** @type {(inputs: Language_Switchtofrenchhelper3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer la langue d'affichage`)
};

const fr_language_switchtofrenchhelper3 = /** @type {(inputs: Language_Switchtofrenchhelper3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer la langue d'affichage`)
};

/**
* | output |
* | --- |
* | "Changer la langue d'affichage" |
*
* @param {Language_Switchtofrenchhelper3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const language_switchtofrenchhelper3 = /** @type {((inputs?: Language_Switchtofrenchhelper3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_Switchtofrenchhelper3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language_switchtofrenchhelper3(inputs)
	return fr_language_switchtofrenchhelper3(inputs)
});
export { language_switchtofrenchhelper3 as "language_switchToFrenchHelper" }